var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCadastroAnalise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.764,
    height: 34.624,
    viewBox: "0 0 32.764 34.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search-alt",
    d: "M20.811,8.062a1.344,1.344,0,0,1,0,2.687H10.062a1.344,1.344,0,0,1,0-2.687ZM16.78,29.56H8.718a4.031,4.031,0,0,1-4.031-4.031V6.718A4.031,4.031,0,0,1,8.718,2.687H24.842a1.344,1.344,0,0,1,1.344,1.344V14.78a1.344,1.344,0,1,0,2.687,0V4.031A4.031,4.031,0,0,0,24.842,0H8.718A6.726,6.726,0,0,0,2,6.718V25.529a6.726,6.726,0,0,0,6.718,6.718H16.78a1.344,1.344,0,0,0,0-2.687Z",
    transform: "translate(-2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "search-alt-2",
    "data-name": "search-alt",
    d: "M20,7.091a1.344,1.344,0,0,1,0,2.687H9.253a1.344,1.344,0,0,1,0-2.687Z",
    transform: "translate(-1.191 5.519)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "search-alt-3",
    "data-name": "search-alt",
    d: "M20,7.091a1.344,1.344,0,0,1,0,2.687H9.253a1.344,1.344,0,0,1,0-2.687Z",
    transform: "translate(-1.191 10.066)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "search-alt-4",
    "data-name": "search-alt",
    d: "M29.387,29.75a1.344,1.344,0,0,1-1.9,0l-3.234-3.234a6.093,6.093,0,1,1,1.9-1.9l3.234,3.234A1.344,1.344,0,0,1,29.387,29.75Zm-8.34-4.981a3.359,3.359,0,1,0-3.359-3.359A3.359,3.359,0,0,0,21.047,24.769Z",
    transform: "translate(2.984 4.48)",
    fill: "#3e44e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadastroAnalise);
export default __webpack_public_path__ + "static/media/cadastro-analise.6bc8165aab29771358d14253430865cb.svg";
export { ForwardRef as ReactComponent };